import { AbstractControl, FormGroup } from '@angular/forms';

/**
 * Check whether abstract control is formgroup
 * @param c Control to check
 * @returns True if it is formGroup
 */
export function isFormGroup(c: AbstractControl): c is FormGroup {
  if ((c as FormGroup).controls) {
    return true;
  }
  return false;
}
